import { useCallback } from "react";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { IntlShape } from "react-intl";

import NylasForm from "@app/scene/settings/type/NylasForm";
import showSaveSettingSuccessfulMessage from "@app/scene/settings/util/showSaveSettingSuccessfulMessage";
import { updateNylas as updateNylasAction } from "@app/store/nylas/actions";
import NylasInfo from "@app/types/nylas/NylasInfo";
import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const useHandleFinish = (
  form: FormInstance<NylasForm>,
  intl: IntlShape,
  onHide: () => void,
  updateNylas: typeof updateNylasAction.request,
  nylasInfo: NylasInfo,
  analyticIssuer?: AnalyticsService
) =>
  useCallback(() => {
    analyticIssuer?.clicked(["Sync Setup", "Save and Start Sync"]);
    const values = form.getFieldsValue();
    const existActivityTypeIds = nylasInfo.nylasCrmActivityTypes.map(({ id }) => id);
    const newActivityTypeIds = values.nylasCrmActivityTypes.map(({ id }) => id);

    updateNylas({
      callback: () => {
        showSaveSettingSuccessfulMessage(intl);
        onHide();
      },
      nylas: {
        ...nylasInfo,
        ...values,
        calendarCrmActivityTypeId: values.calendarCrmActivityType?.id,
        nylasCrmActivityTypes: [
          ...existActivityTypeIds
            .filter((id) => !newActivityTypeIds.includes(id))
            .map((id) => ({
              _action_: "delete",
              crmActivityTypeId: id,
            })),
          ...newActivityTypeIds
            .filter((id) => !existActivityTypeIds.includes(id))
            .map((id) => ({
              _action_: "create",
              crmActivityTypeId: id,
            })),
        ],
        syncOptions:
          Object.values(values.syncOptions).length > 0
            ? values.syncOptions
            : { incoming: false, outgoing: true },
      },
    });
  }, [analyticIssuer, form, intl, nylasInfo, onHide, updateNylas]);

export default useHandleFinish;
